const error = {
  "500": "알 수 없는 오류가 발생했습니다.",
  "501": "지원하지 않는 기능입니다.",
  "502": "서버 게이트웨이 오류가 발생했습니다.",
  "503": "서비스를 일시적으로 사용할 수 없습니다.",
  "504": "서버 응답 시간이 초과되었습니다.",
  "505": "HTTP 버전이 지원되지 않습니다.",
  "000001": "접근 권한이 없습니다.",
  "000002": "인증 절차에 문제가 발생했습니다.", // 리프래시 토큰이 무효화 되었습니다.
  "000003": "인증 절차에 문제가 발생했습니다.", // 리프래시 토큰 형식이 잘못되었습니다.
  "000004": "인증이 만료되었습니다.", // 리프레시 토큰이 만료되었습니다.
  "000005": "금지된 자원입니다.", // 금지된 자원입니다.
  "000006": "NoAuthorization", // 인증이 필요합니다.
  "100001": "검증되지 않은 폰 번호입니다.",
  "100002": "이미 가입된 이메일 입니다.",
  "100003": "확인 후 다시 시도해주세요",
  "100004": "가입되지 않은 셀러입니다.",
  "100005": "시간 선택이 연속적이지 않습니다.",
  "100006": "이미 등록된 시간입니다.",
  "100007": "시작일이 종료일보다 큽니다.",
  "100008": "방송을 찾을 수 없습니다.",
  "100009": "방송 시작 24시간 전입니다.",
  "100010": "시간 선택이 연속적이지 않습니다.",
  "100011": "방송 시작 10분 전입니다.",
  "100012": "이전 최대 인원 수보다 많지 않습니다.",
  "100013": "예약한 방송을 취소할 수 없습니다.",
  "100014": "게시물이 이미 존재합니다.",
  "100015": "상품이 이미 존재합니다.",
  "100016": "결제 실패했습니다.",
  "100017": "게시물을 찾을 수 없습니다.",
  "100018": "내 게시물이 아닙니다.",
  "100019": "내 댓글이 아닙니다.",
  "100020": "잠시 후 다시 시도해주세요.",
  "100021": "인증번호가 일치하지 않습니다.",
  "100022": "이미 가입된 폰번호 입니다.",
  "100023": "이미 가입된 이름 입니다.",
  "100024": "포인트가 부족합니다.",
  "100025": "상품을 수정할 수 없습니다.",
  "100026": "최대 인원수 정보가 맞지 않습니다.",
  "100027": "포인트 정책이 업데이트 되었습니다. 다시 시도해주세요.",
  "100028": "예약시간 정책이 업데이트 되었습니다.다시 시도해주세요.",
  "100029": "인증 유효 시간이 초과되었습니다. 다시 시도해주세요.",
  "100030": "내 방송이 아닙니다.",
  "100031":
    "라이브 예약을 위해 계좌정보가 필요합니다. 등록은 고객센터로 문의해주세요.",
  "100032": "단골 수가 50명 미만입니다.",
  "100033": "계정 활성 승인되면 안내드리겠습니다.",
  "100034":
    "라이브 예약을 위해 배송정보가 필요합니다. 등록은 고객센터로 문의해주세요.",
  "100035": "제목에 금지된 브랜드명이 포함되어 있습니다.",
  "100036":
    "최근 1년동안 닉네임을 변경하신 이력이 있어 지금은 변경하실 수 없습니다.",
  "100037": "소개글 금지 단어 사용",
  "400005": "재고 부족",
  "400026": "특정 단어 조합이 포함된 메시지는 전송할 수 없습니다.",
  "400029":
    "주문에 대한 수량 및 옵션 변경시 클라이언트 상태와 서버 상태가 일치하지 않음",
  "500004": "이미 존재하는 태그 이름입니다.",
  "500005": "태그는 최대 100개까지만 생성할 수 있습니다.",
  "500006": "본인의 채팅방에만 태그를 할당할 수 있습니다.",
  "500007": "유효하지 않은 태그 ID가 포함되어 있습니다.",
  "500008": "본인 소유 태그만 할당하거나 삭제할 수 있습니다.",
  "500009": "채팅방에는 최대 10개의 태그만 할당할 수 있습니다.",
  "500010": "존재하지 않는 태그입니다.",
  "500011": "내 채팅방에만 접근할 수 있습니다.",
  "500012": "메시지에 금칙어가 포함되어 있습니다.",
  "100038": "이미 취소되었거나 환불된 주문입니다.",
  "100039": "주문 건수가 미 일치합니다.",
  "100040": "주문이 존재하지 않습니다.",
  "100041": "존재하지 않는 결제정보 입니다.",
  "100042": "취소 금액이 미 일치 합니다.",
  "100043": "환불 계좌 정보가 존재하지 않습니다.",
  "100044":
    "요청하신 환불 금액이 취소 가능한 금액보다 커서 환불을 진행할 수 없습니다.",
  "100045": "환불 예정 금액이 마이너스 인 경우",
  "100046": "처리할수 없는 주문이 포함되어 있음.",
  "100047": "취소철회가 불가한 상품",
  "100048": "주문 상태 이동 시 환불이 포함된 주문이 있음",
  "100049": "방송 종료 후 처리할 수 있습니다.",
};

export default error;
